import SimpleModal from '@/ui/SimpleModal';
import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { subscriberGateContentContainer, subscriberGateDialogContent } from './SubscriberGate.css';
import type { SubscriberGateElementProps } from './SubscriberGate.types';

export function SubscriberGateElement(props: SubscriberGateElementProps) {
  const { children, element, isOpen = false, isPreviewing = false, onOpenChange } = props;

  const {
    gap,
    width,
    maxWidth,
    padding,
    backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    borderStyle,
    modalOverlayBackgroundColor,
    modalCloseButtonColor = 'inherit',
    modalCloseButtonPlacementTop,
    modalCloseButtonPlacementRight,
  } = element.attrs || {};

  const generatedStyle = {
    '--overlay-background-color': modalOverlayBackgroundColor,
    '--modal-close-button-color': modalCloseButtonColor,
    '--modal-close-button-placement-top': modalCloseButtonPlacementTop,
    '--modal-close-button-placement-right': modalCloseButtonPlacementRight,
  } as CSSProperties;

  const renderedElement = (
    <div
      className={classNames(subscriberGateContentContainer, 'flex flex-col h-auto')}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
          backgroundColor,
          padding,
          borderStyle,
          borderWidth,
          borderRadius,
          borderColor,
          gap,
          '--padding': padding,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );

  if (isPreviewing) {
    return (
      <div className="w-full h-auto min-h-[600px] flex items-end justify-center relative" style={generatedStyle}>
        <div className="absolute top-0 left-0 w-full h-full bg-[--overlay-background-color]">&nbsp;</div>
        <div className="z-10 relative w-full">{renderedElement}</div>
      </div>
    );
  }

  if (!isOpen) {
    return null;
  }

  return (
    <SimpleModal
      placement="bottom"
      isOpen={isOpen}
      onClose={onOpenChange}
      style={generatedStyle}
      showCloseButton={false}
    >
      <div className={classNames(subscriberGateDialogContent)}>{renderedElement}</div>
    </SimpleModal>
  );
}
